import { TipoEstado, TipoEstadoFactory } from './tipo-estado-solicitud';

export class ContenidosPendientes {
    contador = 0;
    registros: ContenidoPendiente[] = [];

    constructor() { }

    static toModel(json: string): ContenidosPendientes {
        const data = JSON.parse(json);
        const toReturn = new ContenidosPendientes();

        toReturn.contador = data.CONTADOR;
        if (data.REGISTROS) {
            toReturn.registros = data.REGISTROS.map((registro: any) => ContenidoPendiente.toModel(JSON.stringify(registro)));
        }

        return toReturn;
    }
}

export class ContenidoPendiente {
    Id: number;
    idSolicitudServicio: number;
    estado: string;
    situacion: string;
    tipoSolicitud: string;
    fechaInicio: Date;
    fechaFinalizacion: Date;
    fechaExpiracion: Date;
    contadorFicheros: number;
    tipoEstado: TipoEstado;

    constructor() { }

    static toModel(json: string) {
        const data = JSON.parse(json);
        const toReturn = new ContenidoPendiente();

        toReturn.Id = data.Id;
        toReturn.idSolicitudServicio = data.ID_SOLICITUD_SERVICIO;
        toReturn.estado = data.ESTADO;
        toReturn.situacion = data.SITUACION;
        toReturn.tipoSolicitud = data.TIPO_SOLICITUD;
        if (data.FECHA_INICIO) {
            toReturn.fechaInicio = new Date(data.FECHA_INICIO);
        }
        if (data.FECHA_FINALIZACION) {
            toReturn.fechaFinalizacion = data.FECHA_FINALIZACION;
        }
        if (data.FECHA_EXPIRACION) {
            toReturn.fechaExpiracion = data.FECHA_EXPIRACION;
        }
        toReturn.contadorFicheros = data.CONTADOR_FICHEROS;
        toReturn.tipoEstado = TipoEstadoFactory.getTipoEstado(data.TIPO_ESTADO);

        return toReturn;
    }
}
